import React, { useLayoutEffect, useRef, useState } from 'react';
import { getTranslation } from '../../constants/translations';
import { getCardsData } from './cardsData';

import './TakingBackControl.scss';

export const TakingBackControl = () => {
  const t = getTranslation();
  const cardsData = getCardsData();
  const staticContainer = useRef<HTMLDivElement>(null);
  const scrollContainer = useRef<HTMLDivElement>(null);
  const thumb = useRef<HTMLDivElement>(null);
  const [thumbPosition, setThumbPosition] = useState(0);
  const [isDrag, setDrag] = useState(false);
  const [isScroll, setIsScroll] = useState(false);

  const add = () => {
    setDrag(true);
  };
  const remove = () => {
    setDrag(false);
  };

  const handlePointerMove = (e: React.MouseEvent) => {
    if (isDrag && staticContainer.current) {
      const thumbMinX = 0;
      const thumbMaxX = (staticContainer.current.clientWidth - 30) as number;
      const staticContainerWidth = staticContainer.current
        .offsetWidth as number;
      const scrollContainerWidth = scrollContainer.current
        ?.offsetWidth as number;
      const thumbWidth = thumb.current?.clientWidth || 0;

      const newThumpPosition =
        e.clientX - (staticContainer.current?.offsetLeft || 0) - 15;
      const referScrollLength =
        (scrollContainerWidth - staticContainerWidth) /
        (staticContainerWidth - thumbWidth);
      if (newThumpPosition < thumbMinX) {
        setThumbPosition(0);
        return;
      }

      if (newThumpPosition > thumbMaxX) {
        setThumbPosition(thumbMaxX);
        return;
      }

      setThumbPosition(newThumpPosition);
      staticContainer.current.scrollLeft = newThumpPosition * referScrollLength;
    }
  };

  useLayoutEffect(() => {
    staticContainer.current?.addEventListener('scroll', function () {
      if (staticContainer.current && scrollContainer.current) {
        const scrollLength = staticContainer.current?.scrollLeft || 0;
        const staticContainerWidth = staticContainer.current
          .offsetWidth as number;
        const scrollContainerWidth = scrollContainer.current
          .offsetWidth as number;
        const thumbWidth = thumb.current?.clientWidth || 0;
        const referScrollLength =
          (staticContainerWidth - thumbWidth) /
          (scrollContainerWidth - staticContainerWidth);

        setThumbPosition(referScrollLength * scrollLength);
      }
    });

    const isTouchScreen =
      'ontouchstart' in window || navigator.maxTouchPoints > 0;

    setIsScroll(
      staticContainer.current!.offsetWidth <
        scrollContainer.current!.offsetWidth && !isTouchScreen,
    );
  }, []);

  return (
    <section
      className="main__control control"
      onPointerMove={handlePointerMove}
      onMouseLeave={() => setDrag(false)}
      onPointerUp={remove}
    >
      <div className="control__titles">
        <h2 className="control__title title">{t.takingBackControl.title}</h2>
        {isScroll && (
          <div className="control__slider-title">
            {t.takingBackControl.slider}
          </div>
        )}
      </div>
      <div className="control__wrapper-container">
        <div ref={staticContainer} className="control__static-container">
          <div
            ref={scrollContainer}
            className="control__scroll-container"
            style={{
              gridTemplateColumns: `repeat(${cardsData.length}, 300px)`,
            }}
          >
            {cardsData.map((card) => (
              <article
                key={card.id}
                className="control__achievement-card achievement-card"
              >
                <div className="achievement-card__title">{card.title}</div>
                {card.isList ? (
                  <ul key={card.id} className="achievement-card__text">
                    {card.listData.map((listItem) => (
                      <li
                        key={listItem}
                        dangerouslySetInnerHTML={{
                          __html: listItem,
                        }}
                      ></li>
                    ))}
                  </ul>
                ) : (
                  <p className="achievement-card__text">{card.content}</p>
                )}
                <div className="achievement-card__author">{card.author}</div>

                <div className="achievement-card__img">
                  <img src={card.imgUrl} alt="Image" />
                </div>
              </article>
            ))}
          </div>
        </div>

        {isScroll && (
          <div className="control__scrollbar">
            <div className="control__scrollbar-track"></div>
            <div
              ref={thumb}
              style={{ left: `${thumbPosition}px` }}
              onPointerDown={add}
              onPointerUp={remove}
              className="control__scrollbar-thumb"
            ></div>
          </div>
        )}
      </div>
    </section>
  );
};
